import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { HaynesProDrawingModel }  from '../typings/haynes-pro.drawing';
import { HaynesProService }       from '../haynes-pro.service';
import { HaynesProSubGroupModel } from '../typings/haynes-pro.sub-group';
import { MessagesService }        from '../../messages/messages.service';
import { VehicleModel }           from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-technical-drawings',
  template: require('./haynes-pro.diagnostic-tool.technical-drawings.component.html')
})
export class HaynesProDiagnosticToolTechnicalDrawingsComponent implements OnChanges, OnInit {

  @BlockUI('haynesProTechnicalDrawingsBlock') block : NgBlockUI;

  @Input() isActive  : boolean;
  @Input() subGroups : Array<HaynesProSubGroupModel>;
  @Input() vehicle   : VehicleModel;

  drawings : Array<HaynesProDrawingModel> = [];
  subGroup : HaynesProSubGroupModel;

  constructor (
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService,
    private messagesService  : MessagesService
  ) {}

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes.isActive && !changes.isActive.isFirstChange() && changes.isActive.currentValue ) {
      const subGroup = this.subGroup
        ? this.subGroup
        : this.subGroups[0];

      subGroup.selected = true;
    }
  }

  ngOnInit () : void {
    if (this.isActive) {
      this.subGroups[0].selected = true;
    }
  }

  handleSubGroupSelection ( subGroup : HaynesProSubGroupModel ) : void {
    this.block.start();

    this.drawings = [];
    this.subGroup = subGroup;

    this.haynesProService.getTechnicalDrawings(this.vehicle, subGroup.name)
    .then(( drawings : Array<HaynesProDrawingModel> ) => {
      this.drawings = drawings;

      if ( !this.isActive ){
        this.haynesProService.updateSubscriptionStatus(true);
      }
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

}